<div class="container-fluid">
  <app-custom-table
    [data]="this.data"
    [loading]="this.is_loading"
    [columns]="this.options"
    [truncationFields]="['job_name']"
    [removalColumns]="['job_id', 'project_id']"
    [isParameterView]="true"
    [linkDefinitions]="this.linkDefinitions"
    [buttonConfig]="this.buttonConfig"
    [inMenuButtonConfig]="this.inMenuButtonConfig"
    [editRow]="false"
    [headerTooltips]="headerTooltips"
    [defaultShowingIds]="this.landingJobs"
    [template]="envVarsTemplate"
  >
  </app-custom-table>
</div>

<ng-template #envVarsTemplate>
  <div
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    "
  >
    <span>
      Environment Variables for {{project_name}}
    </span>
  </div>
</ng-template>
